import React, { useState } from 'react';
import { LuMail, LuLock, LuEye, LuEyeOff, LuShieldCheck } from "react-icons/lu";
import { FaGoogle, FaGithub, FaMicrosoft } from "react-icons/fa";
import "../../asset/css/auth.css";
import { Link, useNavigate } from 'react-router-dom'; // Added useNavigate
import { baseurl } from '../../baseurl';
import axios from 'axios';
import Swal from 'sweetalert2';
import logo from "../../asset/img/white.png";
const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate(); // For redirection after login

  // 1. State for input values
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  // 2. Handle Login Submit
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${baseurl}loginUser`, {
        email,
        password
      });

      console.log("response", response);

      if (response.data.success) {
        // 3. Store token and basic user info in LocalStorage
        localStorage.setItem('userToken', response.data.token);
        localStorage.setItem('userName', response.data.user.firstName);
        localStorage.setItem('userEmail', response.data.user.email);
        
        Swal.fire({
          icon: 'success',
          title: 'Welcome!',
          text: 'Login successful.',
          timer: 1500,
          showConfirmButton: false
        });

        // 4. Redirect to dashboard or home
        setTimeout(() => {
          window.location.href = '/';
        }, 1500);
      }
    } catch (err) {
      console.error("Login error:", err);
      Swal.fire({
        icon: 'error',
        title: 'Login Failed',
        text: err.response?.data?.message || 'Something went wrong. Please check your credentials.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-card">
        
        <div className="form-section">
          {/* <Link to="/" className="back-nav" style={{ textDecoration: 'none', color: 'inherit' }}>
            <span className="arrow">←</span> Back to Home
          </Link> */}

          <div>
      <img src={logo} className='img-fluid' style={{maxHeight:"40px",}} />
    {/* <div className="sub-brand  text-dark">Project Management Dashboard</div> */}
    </div>

          <h1 className="welcome-title">Welcome</h1>
          <p className="subtitle">Log in to your Measro account to continue</p>

          <form className="login-form" onSubmit={handleLogin}>
            <div className="input-field">
              <label>Email Address</label>
              <div className="input-control">
                <LuMail className="icon" />
                <input 
                  type="email" 
                  placeholder="name@company.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required 
                />
              </div>
            </div>

            <div className="input-field">
              <label>Password</label>
              <div className="input-control">
                <LuLock className="icon" />
                <input 
                  type={showPassword ? "text" : "password"} 
                  placeholder="Enter your password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button 
                  type="button" 
                  className="eye-btn"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <LuEyeOff /> : <LuEye />}
                </button>
              </div>
            </div>

            <div className="form-extras">
              {/* <label className="checkbox-container">
                <input type="checkbox" />
                <span className="checkmark"></span>
                Remember me
              </label> */}
              <Link to="/reset-password" className="forgot-link">Forgot password?</Link>
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? "Verifying..." : <><span>➜</span> Log In</>}
            </button>

            {/* <div className="divider">
              <span>Or continue with</span>
            </div> */}

            {/* <p className="sso-label">Single sign-on</p>
            <div className="social-login">
              <button type="button" className="sso-btn"><FaGoogle className="google-icon" /></button>
              <button type="button" className="sso-btn"><FaGithub /></button>
              <button type="button" className="sso-btn"><FaMicrosoft className="ms-icon" /></button>
            </div> */}

            <p className="signup-text">
              Don't have an account? <Link to="/register">Sign up for free</Link>
            </p>
          </form>
        </div>

        <div className="info-section">
          <div className="shield-icon-wrapper">
            <LuShieldCheck />
          </div>
          
          <h2 className="info-title">Measure Smart, Save Time and Spend Less with Measro</h2>
          <p className="info-description">
            <strong className='text-white'>Get reliable measurement reports for landscaping, paving, and snow projects with fast turnaround and lower costs, no site visits needed.</strong>
          </p>
          
          <ul className="feature-list">
            <li><span className="check">✓</span> High-accuracy measurement reports</li>
            <li><span className="check">✓</span> Quick turnaround time - Save time and reduce on-site effort</li>
            <li><span className="check">✓</span> Suitable for landscaping, snow & paving projects</li>
            <li><span className="check">✓</span> Simple and easy-to-use platform</li>
          </ul>

          <div className="secure-badge">
            <LuLock size={14} /> Your login is 100% secure
          </div>
        </div>

      </div>
    </div>
  );
};

export default Login;